import gql from 'graphql-tag'
import styled from 'styled-components'
import useGetQuestionKeywords from '@app.feature/exam/gsat2024-2/hooks/useGetQuestionKeywords'
import useIsAdmin from 'hooks/useIsAdmin'
import KeywordItem from '../../../../../../components/KeywordItem'

gql`
  fragment KeywordList_examQuestionKeywordConnection on ExamQuestionKeywordConnection {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      id
      keyword
    }
  }
`

interface KeywordListDesktopProps {
  questionId: string
}

const KeywordListDesktop = ({ questionId }: KeywordListDesktopProps) => {
  const isAdmin = useIsAdmin()
  const { keywords, ref } = useGetQuestionKeywords({ questionId: questionId })

  if (!keywords?.nodes.length) {
    return <StyledNullKeyword>등록된 키워드가 없습니다.</StyledNullKeyword>
  }

  return (
    <StyledWrapper>
      <div className="scroll-box">
        {keywords?.nodes?.map((keywordData) => {
          return (
            <KeywordItem
              id={keywordData.id}
              label={keywordData.keyword}
              isAdmin={isAdmin}
              key={`${keywordData.id}-${keywordData.keyword}`}
            />
          )
        })}
        {keywords?.pageInfo?.hasNextPage && (
          <div ref={ref} className="infinite-scroll-ref" />
        )}
      </div>
    </StyledWrapper>
  )
}

export default KeywordListDesktop

const StyledNullKeyword = styled.div`
  display: flex;
  align-items: center;
  height: 50px;
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: -0.72px;
  text-align: center;
`

const StyledWrapper = styled.div`
  overflow-y: scroll;
  max-height: 90px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cccccc;
    border-radius: 100px;
  }

  > .scroll-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    column-gap: 8px;
    row-gap: 10px;

    > .infinite-scroll-ref {
      width: 100%;
      height: 1px;
    }
  }
`
